<template>
	<div class="video-wrapper w-[100%] h-[100%]">
		<div class="video-container h-[500px] relative">

			<video-player class="video-player vjs-custom-skin " ref="videoPlayer" :playsinline="true"
				:options="playerOptions" @error="onError" @loadeddata="onloadeddata" @play="onPlay" @pause="onPause"
				@timeupdate="onTimeUpdate" @ended="onEnded">
			</video-player>

			<div class="mplayer-toast" :class="{'mplayer-show':showMplayerToast}">
				<div class="text">{{langInfo['been located']}}{{convertSecondsToHMS(seekTime)}}</div>
			</div>
			<!-- 水印 -->
			<div class="absolute w-full h-full top-0 left-0 bg-repeat pointer-events-none"
				:style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}">
			</div>
			<!-- 水印 -->
			<!-- 试看遮罩 -->
			<div v-if="isTrialOver" class="trial-overlay">
				<div class="trial-message">
					<h3>{{langInfo.preview_over}}</h3>
					<p>{{langInfo['You have watched']}}{{ trialDuration }}{{langInfo['Preview content']}}</p>
					<!-- <button @click="purchase">{{langInfo['Unlock the full video']}}</button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			seekTime: {
				type: Number,
				default: 0
			},
			videoUrl: {
				type: String,
				default: '',
			}, // 视频路径
			trialDuration: {
				type: Number,
				default: 0
			}
		},
		watch: {
			// 监视message属性的变化
			videoUrl: {
				handler(newVal, oldVal) {
					// 这里可以处理 prop 的值变化
					console.log('Prop changed:', newVal);
					this.currentUrl = newVal

					this.playerOptions.sources[0].src = ""

					this.playerOptions.sources[0].src = newVal

					// console.log("this.seekTime1111111===" + this.seekTime);

				},
				immediate: true // 确保在组件创建时立即执行一次
			},
			seekTime: function(newVal, oldVal) {
				console.log('seekTime changed from', oldVal, 'to', newVal);
				this.currentTimeValue = newVal;

				console.log("this.currentTimeValue===" + this.currentTimeValue);
				if (this.currentTimeValue > 0) {
					console.log("进度===" + this.currentTimeValue);
					// this.player.currentTime(this.currentTime)
				}

			}
		},
		data() {

			// aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
			// fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
			return {
				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + '@' + this.$common.currentTime() + '@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,


				showMplayerToast: false,
				playerOptions: {
					height: '500',
					playbackRates: [0.8, 1.0, 1.5, 2.0], // 可选的播放速度
					autoplay: false, // 如果为true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 是否视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4", // 类型
						src: this.videoUrl // url地址
					}],
					poster: '', // 封面地址
					notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: false, // 是否显示剩余时间功能
						fullscreenToggle: true // 是否显示全屏按钮
					},
				},
				isTrialOver: false,
				currentTimeValue: 0,
				langInfo: {},
				currentUrl: '',
			}
		},

		mounted() {
			console.log("this.seekTime===" + this.seekTime);

			this.getdict_data()
		},
		computed: {
			player() {
				console.log("=====");
				var that = this

				return this.$refs.videoPlayer.player
			}
		},

		beforeDestroy() {
			if (this.player.currentTime() > 0) {
				this.$emit('videoClose', { playTime: this.player.currentTime() })
			}
			this.playerOptions.sources[0].src = ""
		},
		destroyed() {
			this.playerOptions.sources[0].src = ""
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

				}).catch((error) => {})
			},
			purchase() {
				
				this.$emit('purchase')
				
			},
			onError(e) {
				console.log("报错");
				console.log(e);

				this.reloadVideoOnError()

			},
			reloadVideoOnError() {
				if (this.player) {
					this.player.pause(); // 暂停当前视频

					this.player.src({
						type: 'video/mp4',
						src: this.currentUrl + '?rnd=' + new Date().getTime()
					}); // 重新设置视频源

				}
			},
			onloadeddata(e) {
				console.log("onloadeddata====");
				console.log(e);

				if (this.seekTime > 0) {
					this.showMplayerToast = true
				}
				this.currentTimeValue = this.seekTime



				if (this.currentTimeValue > 0) {
					console.log("this.currentTime2332323===" + this.currentTimeValue);
					console.log("#23232========");

					console.log("====");
					console.log(this.player);

					this.player.currentTime(this.seekTime)
				}
			},

			onPlay(player) {
				//监听暂停
				console.log('播放');
				console.log(player);
				console.log(this.currentTimeValue);

				// this.player.currentTime(this.currentTime)
				setTimeout(() => {
					this.showMplayerToast = false
				}, 3000)
			},
			onPause(e) {
				console.log('暂停');
				// console.log('暂停');

			},
			onTimeUpdate(e) {

				if (e.currentTime() >= this.trialDuration && this.trialDuration > 0) {
					this.isTrialOver = true
					this.player.currentTime(this.trialDuration)
					this.player.pause() // 暂停				
				}
			},

			onEnded(e) {
				console.log('结束');

			},
			convertSecondsToHMS(seconds) {
				const hours = Math.floor(seconds / 3600);
				const minutes = Math.floor((seconds % 3600) / 60);
				const remainingSeconds = seconds % 60;

				// 在数字小于10时，在前面补零
				const minutesStr = minutes < 10 ? "0" + minutes : minutes;
				const secondsStr = remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;
				if (hours === 0) {
					return minutesStr + ":" + secondsStr;
				} else {
					const hoursStr = hours < 10 ? "0" + hours : hours;
					return hoursStr + ":" + minutesStr + ":" + secondsStr;
				}
			}
		}
	}
</script>


<style scoped>
	.mplayer-toast {
		position: absolute;
		left: 10px;
		bottom: 45px;
		display: flex;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.8);
		border-radius: 2px;
		opacity: 0;
		padding: 6px 8px;
	}

	.mplayer-toast.mplayer-show {
		opacity: 1;
	}

	.mplayer-toast .text {
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 14px;
	}


	/deep/.el-slider__button {
		border: 0 !important;
	}

	/deep/.el-slider__runway {
		background-color: #c3c3c3;
	}

	.video-container {
		position: relative;
		width: 100%;
	}

	.watermarkContent {
		width: 200%;
		height: 200%;
		top: 50%;
		left: 50%;
		overflow: hidden;
		position: absolute;
		pointer-events: none;

		transform: translate(-50%, -50%) rotate(45deg);
		transform-origin: center center;
		/* 确保水印不会阻挡视频操作 */
	}

	.watermark {
		color: #d0d0d0;
		opacity: 0.7;
		font-size: 14px;

	}

	/deep/.vjs_video_3-dimensions {
		width: 100%;
		height: 500px;
	}

	video {
		width: 100%;
		height: 500px;
		display: block;
		object-fit: contain;
	}

	.custom-controls {
		width: 100%;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.4);
		padding: 0 10px;
		height: 50px;
		box-sizing: border-box;
		position: absolute;
	}

	.custom-controls button {
		margin-right: 10px;
		padding: 5px 10px;
		cursor: pointer;
	}

	.custom-controls .el-slider {
		flex-grow: 1;
		margin: 0 10px;
	}

	/* 速度控制样式 */
	.speed-control {
		position: relative;
		display: inline-block;
	}

	.speed-control button {
		width: 40px;
		height: 50px;
		line-height: 50px;
		background: transparent;
		color: #fff;
		padding: 0;
		border: none;
	}

	.speed-menu {
		position: absolute;
		bottom: 50px;
		left: -20px;
		background: rgba(0, 0, 0, 0.8);
		list-style: none;
		border-radius: 4px;
		overflow: hidden;
		z-index: 10;
	}

	.speed-menu li {
		width: 100px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		color: white;
	}

	.speed-menu li:hover {
		background: rgba(255, 255, 255, 0.2);
	}

	.speed-menu li.active {
		background: #2979FF;
		color: white;
	}

	.trial-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 10000;
	}

	.trial-message {
		background: white;
		padding: 20px;
		border-radius: 5px;
		text-align: center;
	}

	.trial-message button {
		margin-top: 10px;
		padding: 8px 16px;
		background-color: #42b983;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}
</style>